import React from 'react';
import MainRegister from './components/MainRegister';

const Register = () => {
  return <MainRegister />;
};

export default Register;
